module.exports = __webpack_public_path__ + "breather-740c6623.png";